import React, { FC } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Heading from 'components/Luxkit/Typography/Heading'

const HeaderContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr;
  height: ${rem(60)};
  padding: 0 ${rem(24)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.five};
`

const StyledHeader = styled.div`
  display: grid;
`

interface HeaderProps {

}

const Header: FC<HeaderProps> = () => {
  return (
    <HeaderContainer>
      <StyledHeader>
        <Heading variant="heading5">
          Connect with our team
        </Heading>
      </StyledHeader>
    </HeaderContainer>
  )
}

export default Header
